import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarContainer,
  GridFilterToolbarButton,
  GridDensitySelector,
} from "@material-ui/data-grid";
import CloseIcon from "@material-ui/icons/Close";
import { ButtonCancel, ButtonSave, ButtonUpdate } from "../../botoes/operacao";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogTitle from "@material-ui/core/DialogTitle";
// import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { Formik } from "formik";

import { Loading } from "../../Loading";
import { ShowMessageBox } from "../../ShowMessageBox";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import DeleteForever from "@material-ui/icons/DeleteForever";

import {
  monitorLimitesDelete,
  monitorLimitesInsert,
  monitorLimitesFindBySitId,
} from "../../../services/MonitorLimitesService";

import { monitorTipoFindAll } from "../../../services/MonitorTipoService";

const useStyles = makeStyles((theme) => ({
  box: {
    display: "flex",
    "flex-direction": "row",
    "justify-content": "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    backgroundColor: "transparent",
  },
  boxPrancheta: {
    width: "800px",
    height: "850px",
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  boxDataGrid: {
    "& .header_grid": {
      backgroundColor: "darkblue",
      color: "white",
    },
    width: "100%",
    height: "300px",

    "& .MuiDataGrid-row.Mui-even:not(:hover)": {
      backgroundColor: "#ccffff",
      color: "black",
    },
    "& .MuiDataGrid-row.Mui-odd:not(:hover)": {
      backgroundColor: "#ffffcc",
      color: "black",
    },
    "& .MuiDataGrid-row.Mui-selected:not(:hover)": {
      backgroundColor: "#999999",
      color: "white",
    },
    "& .MuiDataGrid-row.Mui-selected:hover": {
      backgroundColor: "#999999",
      color: "white",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#999999",
      color: "white",
    },
  },
  input_data: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignContent: "center",
  },
  form: {
    width: "750px", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    flexDirection: "column",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

let severity = "success";
let msg = "";

export default function DialogoMonitoramento(params) {
  const classes = useStyles();
  const [openLoadingDialog, setOpenLoadingDialog] = React.useState(false);
  const [openSnackBarDialog, setOpenSnackBarDialog] = React.useState(false);
  const [listMonitorLimites, setListMonitorLimites] = React.useState([]);
  const [listMonitorTipo, setMonitorTipo] = React.useState([]);

  const [selectionItem, setSelectionItem] = React.useState([]);

  const concluir = async () => {
    params.closeDialogMonitoramento();
  };

  useEffect(async () => {
    setOpenLoadingDialog(true);
    try {
      if (params.selection.sit_id) {
        const respLimites = await monitorLimitesFindBySitId(
          params.selection.sit_id
        );
        const respMonitorTipo = await monitorTipoFindAll();
        setListMonitorLimites(respLimites.data);
        setMonitorTipo(respMonitorTipo.data);
      }
      setOpenLoadingDialog(false);
    } catch (err) {
      console.log(err);
      setOpenLoadingDialog(false);
    }
  }, []);

  const deleteMonitor = async () => {
    setOpenSnackBarDialog(false);
    setOpenLoadingDialog(true);

    console.log("selectionItem", selectionItem);

    try {
      await monitorLimitesDelete(selectionItem.sit_id, selectionItem.mot_id);
      const respLimites = await monitorLimitesFindBySitId(
        params.selection.sit_id
      );
      setListMonitorLimites(respLimites.data);
      setOpenSnackBarDialog(true);
      msg = "Monitor excluido com sucesso";
      severity = "success";
    } catch (error) {
      setOpenSnackBarDialog(true);
      msg = "Erro ao excluir este monitor";
      severity = "error";
    }
    setOpenLoadingDialog(false);
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridFilterToolbarButton />
        <GridDensitySelector />
      </GridToolbarContainer>
    );
  };

  return (
    <Dialog
      open={params.openDialogMonitoramento}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="md"
    >
      <div
        id="form-dialog-title"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          paddingRight: "2rem",
          paddingLeft: "2rem",
          alignItems: "center",
          background: "lightblue",
          height: "4rem",
        }}
      >
        <span style={{ fontSize: "1.2rem" }}>
          Criação de Monitor para Site: <b>{params.selection.sit_nome}</b>
        </span>
        <ButtonCancel
          variant="contained"
          color="primary"
          type="button"
          style={{
            padding: "3px",
            color: "white",
            fontWeight: "bold",
          }}
          onClick={params.closeDialogMonitoramento}
        >
          <CloseIcon />
        </ButtonCancel>
      </div>

      <DialogContent>
        <Loading open={openLoadingDialog} />
        <ShowMessageBox
          open={openSnackBarDialog}
          setOpen={setOpenSnackBarDialog}
          severity={severity}
          msg={msg}
        />
        <div className={classes.boxDataGrid}>
          <DataGrid
            rows={listMonitorLimites}
            disableColumnMenu
            disableColumnReorder
            id="mot_id"
            onRowSelected={(newSelection) => {
              setSelectionItem(newSelection.data);
            }}
            components={{
              Toolbar: CustomToolbar,
            }}
            columns={[
              {
                field: "id",
                headerName: "Opções",
                headerClassName: "header_grid",
                headerAlign: "center",
                flex: 1,
                align: "center",
                renderCell: (params) => {
                  if (params.row.id === selectionItem.id) {
                    return (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <Tooltip title="Delete" aria-label="img">
                          <IconButton onClick={deleteMonitor}>
                            <DeleteForever />
                          </IconButton>
                        </Tooltip>
                      </div>
                    );
                  } else {
                    return (
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <IconButton disabled>
                          <DeleteForever />
                        </IconButton>
                      </div>
                    );
                  }
                },
              },
              {
                field: "mot_id",
                headerName: "Id Monitor",
                headerClassName: "header_grid",
                type: "string",
                headerAlign: "center",
                flex: 1,
                sortable: false,
                editable: true,
              },
              {
                field: "mol_id",
                headerName: "Id",
                headerClassName: "header_grid",
                type: "string",
                headerAlign: "center",
                flex: 1,
                sortable: false,
                editable: true,
              },

              {
                field: "mtv_id",
                headerName: "Unidade",
                headerClassName: "header_grid",
                type: "string",
                headerAlign: "center",
                flex: 1,
              },

              {
                field: "mol_alerta",
                headerName: "Alerta",
                headerClassName: "header_grid",
                type: "string",
                headerAlign: "center",
                flex: 1,
              },
              {
                field: "mol_critico",
                headerName: "Critico",
                headerClassName: "header_grid",
                type: "string",
                headerAlign: "center",
                flex: 1,
              },
            ]}
          />
        </div>
        <div>
          <Formik
            initialValues={{
              mot_id: null,
              mol_id: null,
              mol_alerta: null,
              mol_critico: null,
            }}
            validate={(values) => {
              const errors = {};
              if (!values.mot_id) {
                errors.mot_id = "Obrigatório";
              }
              if (!values.mol_alerta) {
                errors.mol_alerta = "Obrigatório";
              }
              if (!values.mol_critico) {
                errors.mol_critico = "Obrigatório";
              }
              if (Number(values.mol_alerta) > Number(values.mol_critico))
                errors.mol_alerta = "Alerta não pode ser superior ao Critico";
              return errors;
            }}
            onSubmit={async (
              values,
              { setSubmitting, resetForm, setFieldValue }
            ) => {
              setSubmitting(true);
              setOpenSnackBarDialog(false);
              setOpenLoadingDialog(true);
              try {
                await monitorLimitesInsert({
                  sit_id: params.selection.sit_id,
                  mot_id: values.mot_id,
                  mol_id: values.mol_id,
                  mol_alerta: values.mol_alerta,
                  mol_critico: values.mol_critico,
                });
                const respLimites = await monitorLimitesFindBySitId(
                  params.selection.sit_id
                );
                setListMonitorLimites(respLimites.data);
                msg = "Monitor incluido com sucesso";
                severity = "success";
                setOpenSnackBarDialog(true);
                setOpenLoadingDialog(false);
                setSubmitting(false);
                setFieldValue("mot_id", null);
                setFieldValue("mol_id", null);
                setFieldValue("mol_alerta", null);
                setFieldValue("mol_critico", null);
              } catch (err) {
                msg = "Erro ao inserir Monitor. Verifique se ele ja existe.";
                severity = "error";
                setOpenLoadingDialog(false);
                setOpenSnackBarDialog(true);
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
              resetForm,
              isValid,
            }) => (
              <div className={classes.input_data}>
                <form onSubmit={handleSubmit} className={classes.form}>
                  <FormControl className={classes.formControl} fullWidth={true}>
                    <InputLabel id="label-mot_id">Monitor</InputLabel>

                    <Select
                      labelId="label-mot_id"
                      id="mot_id"
                      name="mot_id"
                      value={values.mot_id}
                      style={{ width: "100%", marginTop: "1.2rem" }}
                      onChange={handleChange}
                    >
                      {listMonitorTipo.map((option) => (
                        <MenuItem key={option.mot_idid} value={option.mot_id}>
                          {option.mot_id + "(" + option.mtv_id + ")"}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    value={values.mol_id}
                    id="mol_id"
                    name="mol_id"
                    label="Identificador"
                    type="string"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth={true}
                    helperText={errors.mol_id}
                    style={{ width: "100%", marginTop: "1.2rem" }}
                  />

                  <TextField
                    value={values.mol_alerta}
                    id="mol_alerta"
                    name="mol_alerta"
                    label="Alerta"
                    type="number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth={true}
                    style={{ width: "100%", marginTop: "1.2rem" }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={errors.mol_alerta}
                  />
                  <TextField
                    value={values.mol_critico}
                    id="mol_critico"
                    name="mol_critico"
                    label="Crítico"
                    type="number"
                    style={{ width: "100%", marginTop: "1.2rem" }}
                    onChange={handleChange}
                    fullWidth={true}
                    onBlur={handleBlur}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    helperText={errors.mol_critico}
                  />

                  <div
                    style={{
                      display: "flex",
                      padding: "2rem",
                      justifyContent: "space-between",
                    }}
                  >
                    <ButtonUpdate
                      variant="contained"
                      size="small"
                      color="primary"
                      type="submit"
                      disabled={!isValid}
                      style={{
                        padding: "5px",
                        color: "white",
                        fontWeight: "bold",
                        height: "2rem",
                        width: "5rem",
                      }}
                    >
                      Novo
                    </ButtonUpdate>

                    <ButtonSave
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={concluir}
                      style={{
                        padding: "5px",
                        color: "white",
                        fontWeight: "bold",
                        height: "2rem",
                        width: "5rem",
                      }}
                    >
                      Concluir
                    </ButtonSave>
                  </div>
                </form>
              </div>
            )}
          </Formik>
        </div>
      </DialogContent>
    </Dialog>
  );
}
